import Vue from 'vue'
import Router from 'vue-router'

import definitions from '../definitions'

const Login = () =>
  import('./components-internal/views/authentication/Login.vue')
const ResetPw = () =>
  import('@/components-shared/views/authentication/ResetPw.vue')
const ConfirmMail = () =>
  import('@/components-shared/views/authentication/confirmMail.vue')
const LoadingDestination = () =>
  import('@/components-shared/views/utils/LoadingDestination.vue')
const Profile = () => import('@/components-shared/views/users/Profile.vue')

/* admin panel */
const NoAccess = () =>
  import('@/components-shared/views/authentication/NoAccess.vue')

/* pe backend */
const OverviewPricing = () =>
  import('./components-internal/views/pricing/OverviewPricing.vue')
const PriceHistory = () =>
  import('./components-internal/views/pricing/PriceHistory.vue')
const PricingDetails = () =>
  import('./components-internal/views/pricing/PricingDetails.vue')
const PriceOverrideViewForEvents = () =>
  import('./components-internal/views/pricing/PriceOverrideViewForEvents')
const PricingSettings = () =>
  import('./components-internal/views/pricing/PricingSettings.vue')
const PricingAnalytics = () =>
  import('./components-internal/views/pricing/PricingAnalytics.vue')

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    /* BACKEND */

    /* PRICING ENGINE */
    {
      path: '/backend/pricing/overview',
      name: 'overviewPricing',
      component: OverviewPricing,
      props: true,
      meta: {
        icon: 'fa-tachometer-alt-fast',
        requiredPermission:
          definitions.permissions.frontend.FRONTEND_ACCESS_PE_OVERVIEW,
        defaultDestinationAllowed: true,
      },
    },
    {
      path: '/backend/pricing/history/:date',
      name: 'priceHistory',
      component: PriceHistory,
      props: true,
      meta: {
        requiredPermission:
          definitions.permissions.frontend.FRONTEND_ACCESS_PE_OVERVIEW,
        defaultDestinationAllowed: true,
        excludeFromNavigation: true,
      },
    },
    {
      path: '/backend/pricing/details',
      name: 'pricingDetails',
      component: PricingDetails,
      props: true,
      meta: {
        icon: 'fa-tags fa-flip-horizontal',
        defaultDestinationAllowed: true,
        requiredPermission:
          definitions.permissions.frontend.FRONTEND_ACCESS_PE_DETAILS,
        excludeFromNavigationIfStaticPriced: true,
      },
    },

    {
      path: '/backend/pricing/event/price',
      name: 'priceOverrideViewForEvents',
      component: PriceOverrideViewForEvents,
      props: true,
      meta: {
        defaultDestinationAllowed: true,
        excludeFromNavigation: true,
        requiredPermission:
          definitions.permissions.frontend
            .FRONTEND_ACCESS_PE_EDIT_PRICES_RULE_BASED,
      },
    },

    {
      path: '/backend/pricing/analytics',
      name: 'pricingAnalytics',
      component: PricingAnalytics,
      props: true,
      meta: {
        icon: 'fa-signal-alt-3',
        requiredPermission:
          definitions.permissions.frontend.FRONTEND_ACCESS_PE_ANALYTICS,
        defaultDestinationAllowed: true,
        withLock: true,
      },
    },

    {
      path: '/backend/pricing/settings',
      name: 'pricingSettings',
      component: PricingSettings,
      props: true,
      meta: {
        icon: 'fa-cog',
        requiredPermission:
          definitions.permissions.frontend.FRONTEND_ACCESS_PE_SETTINGS,
        defaultDestinationAllowed: true,
      },
    },

    {
      path: '/noAccess',
      name: 'noAccess',
      component: NoAccess,
      meta: {
        defaultDestinationAllowed: true,
      },
      props: true,
    },

    // root path
    {
      path: '/',
      props: true,
      component: Login,
      // handle browser history
    },
    {
      path: '/preparing',
      name: 'loadingDestination',
      component: LoadingDestination,
      props: true,
    },

    {
      path: '/user/profile',
      name: 'profile',
      component: Profile,
      meta: {
        defaultDestinationAllowed: true,
        loginRequired: true,
      },
      props: true,
    },

    // login
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        // ATTENTION: this defaultDestinationAllowed meta value does not really have influence. Can always be reached => see main.js => beforeEachRoute()
        defaultDestinationAllowed: true,
      },
      props: true,
    },

    // reset pw
    {
      path: '/resetPw',
      name: 'resetPw',
      component: ResetPw,
      meta: {
        defaultDestinationAllowed: true,
      },
      props: true,
    },

    // confirm mail address
    {
      path: '/confirmMail/:mail/:code/:mode',
      name: 'confirmMail',
      component: ConfirmMail,
      props: true,
    },
  ],
})
